module.exports = __webpack_public_path__ + "static/media/29.2941c705.png";